<script setup>
import { EnvelopeIcon, EyeIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import SendEmailAction from "@js/components/actions/SendEmailAction.vue";
import { useRoute } from "@js/utils/route";
import { toast } from "vue3-toastify";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { row, callback } = defineProps({
  row: {
    type: Object,
    required: true,
  },
  callback: {
    type: Function,
    required: true,
  },
});

const { route } = useRoute();

function sendActionCallback(from, to, subject, body, setLoading, setIsOpen) {
  let url = route(
    "front.projectManagement.task.postSendCustomerTaskEmailReminder",
    {
      tenant: row.original.id,
    },
  );

  let postData = {
    from: from,
    to: to,
    subject: subject,
    body: body,
  };

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-TOKEN": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    },
    body: JSON.stringify(postData),
  })
    .then(() => {
      setLoading(false);
      setIsOpen(false);
      toast.success(t("toast.successfullySent"), { position: "top-right" });
      callback();
    })
    .catch((error) => {
      console.error(error);
    });
}
</script>

<template>
  <div class="flex h-full flex-row items-center gap-2 p-4">
    <ActionButton
      size="small"
      class="size-8"
      :title="t('button.see')"
      type="secondary"
      :href="
        route('front.projectManagement.task.customerTasks', {
          tenant: row.original.id,
        })
      "
      :icon="EyeIcon"
    />

    <SendEmailAction
      :from-options="row.original.email.fromOptions"
      :to-options="row.original.email.toOptions"
      :to="row.original.email.toOptions"
      :subject="row.original.email.subject"
      :body="row.original.email.body"
      :callback="sendActionCallback"
    >
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          class="size-8"
          type="primary"
          :title="t('button.sendEmail')"
          :callback="() => setIsOpen(true)"
          :icon="EnvelopeIcon"
        >
        </ActionButton>
      </template>
    </SendEmailAction>
  </div>
</template>
